export default __webpack_public_path__ + "static/media/threat4.915638e9.png";